import { render, staticRenderFns } from "./ExtensionRestorationView.vue?vue&type=template&id=8860cbee&scoped=true"
import script from "./ExtensionRestorationView.vue?vue&type=script&lang=js"
export * from "./ExtensionRestorationView.vue?vue&type=script&lang=js"
import style0 from "./ExtensionRestorationView.vue?vue&type=style&index=0&id=8860cbee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8860cbee",
  null
  
)

export default component.exports